import request from "project-config/services/request/request";
import { message } from "antd";
import { AccountType, STORAGE, Zone } from "project-config/constants";
import { UserInfo } from "@/utils/userinfo/types";
import Cookie from "project-config/utils/cookie";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { isDev } from "project-config/utils/env";
import { getDomainName } from "project-config/utils/domain";

export async function redirectToAuth(
  userInfo?: UserInfo,
  block = false,
  url = "/authenticate"
) {
  if (!userInfo || block) return;

  if (Cookie.getCookie("rayvision_isAuthLogin")) return;

  const t = getTranslateNsT("profile");
  const canJump =
    userInfo?.zone === Zone.Domestic &&
    userInfo.accountType === AccountType.Main;

  if (!canJump) return;

  const { data, code } = await request.post(
    "/api/rendering/user/generateRealNameAuth"
  );

  if (code === 1205) {
    message.error(t("user_auth_certified_config_invalid"));
    return;
  }

  if (code === 200) {
    const authenticateLink = isDev() ? "http://account-pre" : "https://account";

    const LanguageParams =
      Cookie.getCookie(STORAGE.LANGUAGE_FLAG) === "1"
        ? "&language=en"
        : "&language=zh";

    const domain = window.location.hostname.includes("127.0.0.1")
      ? "http://127.0.0.1:3001"
      : `${authenticateLink}.${getDomainName(2)}.${getDomainName(1)}`;
    const tail = `${url}?token=${data}${LanguageParams}`;

    // To use window.open() in safari you must put it in an element's onclick event attribute.
    const link = `${domain}${tail}`;
    const windowReference = window.open(link);
    if (windowReference === null) {
      window.location.href = link;
    }
  }
}
